import axios from "axios";
// export const BACKEND_URL = 'http://localhost:1337'
export const BACKEND_URL = 'https://back.phoenix-programs.ru'

const instanse = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const storesApi = {
    getMainAndInfoCompany() {
        return instanse.get('/main')
    },
    getProjects() {
        return instanse.get('/projects?populate=*')
    },
    getDetailProject(id: number) {
        return instanse.get(`/projects/${id}?populate=*`)
    },
    getArticles() {
        return instanse.get('/articles?populate=*')
    },
    getAboutUs() {
        return instanse.get('/about-us')
    },
    getProducts() {
        return instanse.get('/products')
    },
    getDetailProduct(id: number) {
        return instanse.get(`/products/${id}`)
    },
    getPrivacyPolicy() {
        return instanse.get('/privacy-policy')
    },
}


